document.documentElement.classList.remove('no-js');

(function () {
  const recommendations = document.querySelectorAll('[data-product-recommendations]');
  recommendations.forEach((section) => {
    const url = section.dataset.url;
    const sectionId = section.dataset.sectionId;
    if (!url || !sectionId) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const loaded = html.querySelector(`#shopify-section-${sectionId}`);
        if (loaded && loaded.innerHTML.trim().length) {
          section.innerHTML = loaded.innerHTML;
        }
      })
      .catch(() => {});
  });
})();

(function () {
  document.querySelectorAll('.product-media__thumbs img').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = thumb.closest('.product-media').querySelector('.product-media__main img');
      if (!main) return;
      main.src = thumb.src.replace(/width=180/g, 'width=1200');
      main.alt = thumb.alt;
    });
  });
})();


(function () {
  document.querySelectorAll('.site-nav__details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.site-nav__details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.site-nav__details')) return;
    document.querySelectorAll('.site-nav__details[open]').forEach((details) => details.removeAttribute('open'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-nav__details[open]').forEach((details) => details.removeAttribute('open'));
  });
})();
